import { createColumnHelper } from '@tanstack/react-table'
import { formatCurrency } from '../../reports/v3/utils/formatCurrency'
import { NavLink } from 'react-router-dom'
import type { InvoiceData } from '../../../types'
import { formatDate } from '../../../utils/tableFuncs'

export default function invoiceData() {
  const columnHelper = createColumnHelper<InvoiceData>()

  return [
    columnHelper.accessor('invoiceNumber', {
      id: 'invoiceNumber',
      header: () => 'Fakturanummer',
      enableSorting: false,
      cell: (info) =>
        info.row.original.consolidateInvoiceNumber ? (
          <NavLink
            to={`/reports/invoice/${info.row.original.consolidateInvoiceNumber}`}
            style={{
              paddingLeft: `${info.row.depth * 2}rem`,
            }}
          >
            {info.getValue()}
          </NavLink>
        ) : (
          info.row.original.invoiceNumber
        ),
    }),
    columnHelper.accessor('invoiceDate', {
      id: 'invoiceDate',
      header: () => 'Fakturadato',
      cell: (info) => formatDate(info.getValue()) || '',
    }),
    columnHelper.accessor('dueDate', {
      id: 'dueDate',
      header: () => 'Forfallsdato',
      cell: (info) => formatDate(info.getValue()) || '',
    }),
    columnHelper.display({
      id: 'status',
      header: () => 'Status',
      enableSorting: false,
      cell: ({ row }) => {
        const dueDate = new Date(row.original.dueDate)
        if (dueDate < new Date()) {
          return 'Forfalt'
        }
        return 'Ikke forfalt'
      },
    }),
    columnHelper.accessor('totalAmount', {
      id: 'totalAmount',
      meta: {
        alignmentType: 'right',
      },
      header: () => 'Totalbeløp',
      cell: (info) => formatCurrency(info.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('totalAmount') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
    columnHelper.accessor('remainingAmount', {
      id: 'remainingAmount',
      meta: {
        alignmentType: 'right',
      },
      header: () => 'Restbeløp',
      cell: (info) => formatCurrency(info.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('remainingAmount') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
  ]
}
